import { Circle, Hexagon, Shapes, Spline } from 'lucide-react'
import { orderAttributeKeys } from '../../utils/attributeOrder'

const ICONES_GEOMETRIE = {
  Point: Circle,
  MultiPoint: Circle,
  LineString: Spline,
  MultiLineString: Spline,
  Polygon: Hexagon,
  MultiPolygon: Hexagon,
}

export const iconeGeometrie = type => ICONES_GEOMETRIE[type] || Shapes

export const estAttributSysteme = cle => cle === 'id' || cle.startsWith('elda_')

export const attributsVisibles = (feature, ordre) => {
  const entrees = Object.entries(feature?.properties || {}).filter(
    ([cle, valeur]) =>
      !estAttributSysteme(cle) && valeur !== null && valeur !== undefined,
  )
  if (!Array.isArray(ordre) || ordre.length === 0) return entrees

  const parCle = new Map(entrees)
  return orderAttributeKeys(Array.from(parCle.keys()), ordre).map(cle => [
    cle,
    parCle.get(cle),
  ])
}

export const formaterCle = cle =>
  cle
    .replace(/_/g, ' ')
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, c => c.toUpperCase())
    .trim()

export const formaterValeur = valeur => {
  if (typeof valeur === 'boolean') return valeur ? 'Oui' : 'Non'
  if (typeof valeur === 'number')
    return new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(
      valeur,
    )
  if (typeof valeur === 'object') return JSON.stringify(valeur)
  return String(valeur)
}
